import FinishMessage from './FinishMessage.vue';

export default FinishMessage;



// WEBPACK FOOTER //
// ./src/components/ordersProcessForms/parts/finishMessage/index.ts